<div class="_statistic-filter-component">

	<button type="button" (click)="onRefresh()" class="_button _refresh-button">
		<ion-icon name="refresh"></ion-icon>
	</button>

	<div class="_filters-container">
		<button type="button" class="_button _filter-button" (click)="onShowFiltersMenu()" *ngIf="filtersAreSet()">
			<ion-icon name="filter-outline"></ion-icon>
		</button>
		<div class="_filters-menu" *ngIf="showingFiltersMenu">
			<ng-container *ngFor="let item of $any(filters) | keyvalue">
				<div class="_filter" (click)="onFilterToggle($any(item).value, $any(item).key)" [ngClass]="{'_visible': $any(item).value.visible}">
					<p>{{ 'FILTERS.' + $any(item).value.name + '.TITLE' | translate }}</p>
					<ion-icon name="checkmark-outline"></ion-icon>
				</div>
			</ng-container>
		</div>
	</div>

	<ng-container *ngIf="filters?.dateRange?.visible">
		<date-filter-component name="{{ 'FILTERS.' + filters?.dateRange?.name + '.TITLE' | translate }}" (filter)="onDateRangeFilter($event)" [dateRange]="params.dateRange"></date-filter-component>
	</ng-container>

	<!-- CLIENT FILTERS -->
	<ng-container *ngIf="filters?.zipcode?.visible">
		<input-filter-component 
			name="{{ 'FILTERS.' + filters?.zipcode?.name + '.TITLE' | translate }}" placeholder="{{ 'FILTERS.ZIPCODE.PLACEHOLDER' | translate }}" (filter)="onZipcodeFilter($event)" [input]="params.zipcode">
		</input-filter-component>
	</ng-container>
	<ng-container *ngIf="filters?.ClientOriginId?.visible">
		<select-filter-component 
			name="{{ 'FILTERS.' + filters?.ClientOriginId?.name + '.TITLE' | translate }}" placeholder="{{ 'FILTERS.CLIENT_ORIGIN.PLACEHOLDER' | translate }}" (filter)="onClientOriginFilter($any($event))" [data]="clientOrigins">
		</select-filter-component>
	</ng-container>
	<ng-container *ngIf="filters?.gender?.visible">
		<select-filter-component 
			name="{{ 'FILTERS.' + filters?.gender?.name + '.TITLE' | translate }}" placeholder="{{ 'FILTERS.GENDER.PLACEHOLDER' | translate }}" (filter)="onGenderFilter($any($event))" [data]="genders" [input]="params.gender">
		</select-filter-component>
	</ng-container>
	<ng-container *ngIf="filters?.ageCategory?.visible">
		<select-filter-component 
			name="{{ 'FILTERS.' + filters?.ageCategory?.name + '.TITLE' | translate }}" placeholder="{{ 'FILTERS.AGE_CATEGORY.PLACEHOLDER' | translate }}" (filter)="onAgeCategoryFilter($any($event))" [data]="ageCategories">
		</select-filter-component>
	</ng-container>
	<ng-container *ngIf="filters?.devices?.visible">
		<select-filter-component 
			name="{{ 'FILTERS.' + filters?.devices?.name + '.TITLE' | translate }}" placeholder="{{ 'FILTERS.CLIENT_DEVICETYPE.PLACEHOLDER' | translate }}" (filter)="onDevicesFilter($any($event))" [data]="deviceTypes">
		</select-filter-component>
	</ng-container>
	<ng-container *ngIf="filters?.digibankTargetAudience?.visible">
		<select-filter-component 
			name="{{ 'FILTERS.' + filters?.digibankTargetAudience?.name + '.TITLE' | translate }}" placeholder="{{ 'FILTERS.TARGET_AUDIENCE.PLACEHOLDER' | translate }}" (filter)="onTargetAudienceFilter($any($event))" [data]="digibankTargetAudiences">
		</select-filter-component>
	</ng-container>

	<!-- ACTIVITY FILTERS -->
	<ng-container *ngIf="filters?.locationZipcode?.visible">
		<input-filter-component 
			name="{{ 'FILTERS.' + filters?.locationZipcode?.name + '.TITLE' | translate }}" placeholder="{{ 'FILTERS.ZIPCODE.PLACEHOLDER' | translate }}" (filter)="onLocationZipcodeFilter($event)" [input]="params.locationZipcode">
		</input-filter-component>
	</ng-container>
	<ng-container *ngIf="filters?.EventTypeId?.visible">
		<select-filter-component 
			name="{{ 'FILTERS.' + filters?.EventTypeId?.name + '.TITLE' | translate }}" placeholder="{{ 'FILTERS.EVENT_TYPE.PLACEHOLDER' | translate }}" (filter)="onEventTypeFilter($any($event))" [data]="eventTypes">
		</select-filter-component>
	</ng-container>
	<ng-container *ngIf="filters?.attendanceType?.visible">
		<select-filter-component 
			name="{{ 'FILTERS.' + filters?.attendanceType?.name + '.TITLE' | translate }}" placeholder="{{ 'FILTERS.ATTENDANCE_TYPE.PLACEHOLDER' | translate }}" (filter)="onAttendanceTypeFilter($any($event))" [data]="attendanceTypes">
		</select-filter-component>
	</ng-container>
	<ng-container *ngIf="filters?.DigibankAgencyId?.visible">
		<select-filter-component 
			name="{{ 'FILTERS.' + filters?.DigibankAgencyId?.name + '.TITLE' | translate }}" placeholder="{{ 'FILTERS.DIGIBANK_AGENCY.PLACEHOLDER' | translate }}" (filter)="onDigibankAgencyFilter($any($event))" [data]="agencies">
		</select-filter-component>
	</ng-container>
	<ng-container *ngIf="filters?.digibankObjective?.visible">
		<select-filter-component 
			name="{{ 'FILTERS.' + filters?.digibankObjective?.name + '.TITLE' | translate }}" placeholder="{{ 'FILTERS.DIGIBANK_OBJECTIVE.PLACEHOLDER' | translate }}" (filter)="onDigibankObjectiveFilter($any($event))" [data]="digibankObjectives">
		</select-filter-component>
	</ng-container>
	<ng-container *ngIf="filters?.LocationId?.visible">
		<select-filter-component 
			name="{{ 'FILTERS.' + filters?.LocationId?.name + '.TITLE' | translate }}" placeholder="{{ 'FILTERS.LOCATION.PLACEHOLDER' | translate }}" (filter)="onLocationFilter($any($event))" [data]="locations">
		</select-filter-component>
	</ng-container>

	<!-- LOAN FILTERS -->
	<ng-container *ngIf="filters?.DeviceTypeId?.visible">
		<select-filter-component 
			name="{{ 'FILTERS.' + filters?.DeviceTypeId?.name + '.TITLE' | translate }}" placeholder="{{ 'FILTERS.DEVICETYPE.PLACEHOLDER' | translate }}" (filter)="onDeviceTypeFilter($any($event))" [data]="deviceTypeIds">
		</select-filter-component>
	</ng-container>

</div>



